"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORCAD_DSN_CFB_STREAM_SPECS = void 0;
exports.ORCAD_DSN_CFB_STREAM_SPECS = [
    { name: 'dsn-stream', path: /^Root Entry\/DsnStream$/, framing: 'json', records: [] },
    { name: 'library', path: /^Root Entry\/Library$/, framing: 'whole-stream', records: [] },
    { name: 'parts-directory', path: /^Root Entry\/Parts Directory$/, framing: 'whole-stream', records: [] },
    { name: 'packages-directory', path: /^Root Entry\/Packages Directory$/, framing: 'whole-stream', records: [] },
    { name: 'schematic', path: /^Root Entry\/Views\/[^/]+\/Schematic$/, framing: 'whole-stream', records: [] },
    {
        name: 'hierarchy',
        path: /^Root Entry\/Views\/[^/]+\/Hierarchy\/Hierarchy$/,
        framing: 'terminated-records',
        records: [],
    },
    {
        name: 'cis-schematic-info',
        path: /^Root Entry\/Views\/[^/]+\/CISSchematic\/SchematicInfoStorage\/[^/]+$/,
        framing: 'whole-stream',
        records: [],
    },
    { name: 'variant-text', path: (entry) => entry.path.includes('/VariantStore/'), framing: 'text', records: [] },
    { name: 'cache', path: /^Root Entry\/Cache$/, framing: 'terminated-records', records: [] },
    { name: 'package', path: /^Root Entry\/Packages\/[^/]+$/, framing: 'terminated-records', records: [] },
    { name: 'symbol', path: /^Root Entry\/Symbols\/[^/]+$/, framing: 'terminated-records', records: [] },
    { name: 'page', path: /^Root Entry\/Views\/[^/]+\/Pages\/[^/]+$/, framing: 'page-records', records: [] },
    { name: 'text', path: /\.txt$/i, framing: 'text', records: [] },
];
//# sourceMappingURL=OrcadDsnCfbStreamSpecs.js.map